import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  TextField,
  makeStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

/* ------------------------- Importaciones internas ------------------------- */
import { cancelButton, saveButton } from "../../../../core/styles/ui.constants";
import BotonGenerico from "../../../../components/Button/Button";
import DialogFooter from "../../../../components/DialogFooter/DialogActions";

/* --------------------------------- Estilos -------------------------------- */
const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(3),
    width: "100%",
    maxWidth: "900px",
  },
  closeButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  titleText: {
    textAlign: "left",
    marginBottom: theme.spacing(2),
  },
  formRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(2),
    flexWrap: "wrap",
  },
  formRowItem: {
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(2),
  },
  field: {
    width: "32%",
    marginBottom: theme.spacing(2),
  },
  descriptionField: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  selectContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  selectField: {
    width: "100%", // Select ocupa el 80% del ancho
  },
  addIcon: {
    marginLeft: theme.spacing(2),
  },
  buttonArea: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  actionButton: saveButton,
  cancelButton: { ...cancelButton, marginLeft: theme.spacing(2) },
  autocompleteInputRoot: {
    "& .MuiOutlinedInput-root": {
      minHeight: 56, // Ajustá este valor a lo que necesites
    },
  },
}));

const AgregarItemsModal = ({
  open,
  onClose,
  onGuardarItem,
  resetFormulario,
  initialItem = null,
}) => {
  const classes = useStyles();

  const formDefaultValues = {
    itemName: "",
    cantidad: "",
    precioUnitario: "",
    precioTotal: "",
    descripcion: "",
    precioDefault: "",
  };

  const [formData, setFormData] = useState(formDefaultValues);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    if (!formData.itemName.trim())
      newErrors.itemName = "El item es obligatorio.";

    if (!formData.cantidad || parseFloat(formData.cantidad) <= 0) {
      newErrors.cantidad = "Por favor, ingresa una cantidad mayor a 0.";
    }

    if (!formData.precioUnitario || parseFloat(formData.precioUnitario) < 0) {
      newErrors.precioUnitario = "Por favor, ingresa un precio mayor o igual a 0.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    if (open && initialItem) {
      setFormData({
        itemName: initialItem.itemName || "",
        cantidad: initialItem.cantidad || "",
        precioUnitario: initialItem.precioUnitario || "",
        precioTotal: initialItem.precioTotal || "",
        descripcion: initialItem.descripcion || "",
        precioDefault: initialItem.precioDefault || "",
      });
      setErrors({});
    } else if (resetFormulario || (open && !initialItem)) {
      setFormData(formDefaultValues);
      setErrors({});
    }
  }, [initialItem, open, resetFormulario]);

  useEffect(() => {
    const cantidadNum = parseFloat(formData.cantidad) || 0;
    const precioUnitarioNum = parseFloat(formData.precioUnitario) || 0;
    const total = cantidadNum * precioUnitarioNum;
    setFormData((prev) => {
      const nextPrecioTotal = total.toFixed(2);
      return prev.precioTotal === nextPrecioTotal
        ? prev
        : { ...prev, precioTotal: nextPrecioTotal };
    });
  }, [formData.cantidad, formData.precioUnitario]);

  // useEffect(() => {
  //   if (open) {
  //     const fetchItem = async () => {
  //       const resultados = await api.items.getAll();
  //       setListaItem(resultados);
  //     };
  //     fetchItem();
  //   }
  // }, [open]);

  const handleSave = () => {
    if (!validate()) return;

    const nuevoItem = {
      // IdItems: formData.IdItems,
      // codigoItem: formData.codigoItem,
      // nombre: formData.nombre,
      itemName: formData.itemName,
      cantidad: formData.cantidad,
      precioUnitario: formData.precioUnitario,
      precioTotal: formData.precioTotal,
      descripcion: formData.descripcion,
    };

    onGuardarItem(nuevoItem);
    onClose();
  };

  // Filtra la lista según el texto de búsqueda
  // const listaFiltrada = listaItem?.filter((item) =>
  //   `${item.codigoItem} - ${item.nombre || "Sin nombre"}`
  //     .toLowerCase()
  //     .includes(searchItem.toLowerCase())
  // );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle disableTypography>
        <Typography variant="h6" className={classes.titleText}>
          {initialItem ? "Editar Item" : "Agregar Item"}
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <div className={classes.formRowItem}>
          <Typography variant="subtitle1" style={{ marginBottom: 4 }}>
            Nombre
          </Typography>
          <TextField
            value={formData.itemName || ""}
            onChange={(e) => {
              const inputValue = e.target.value;
              setFormData({ ...formData, itemName: inputValue });
            }}
            variant="outlined"
            type="text"
            fullWidth
            error={!!errors.itemName || undefined}
          />
          {errors.itemName && (
            <Typography color="error" variant="body2">
              {errors.itemName}
            </Typography>
          )}
        </div>
        <div className={classes.formRow}>
          <div style={{ width: "33%" }}>
            <Typography variant="subtitle1">Cantidad</Typography>
            <TextField
              variant="outlined"
              fullWidth
              type="number"
              inputProps={{ min: 0 }}
              value={formData.cantidad}
              error={!!errors.cantidad || undefined}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || Number(value) >= 0) {
                  setFormData({ ...formData, cantidad: value });
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />
            {errors.cantidad && (
              <Typography color="error" variant="body2">
                {errors.cantidad}
              </Typography>
            )}
          </div>
          {/* Precio Unitario */}
          <div style={{ width: "33%" }}>
            <Typography variant="subtitle1">Precio Unitario ($)</Typography>
            <TextField
              variant="outlined"
              fullWidth
              type="number"
              inputProps={{ min: 0 }}
              value={formData.precioUnitario}
              error={!!errors.precioUnitario || undefined}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || Number(value) >= 0) {
                  setFormData({ ...formData, precioUnitario: value });
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />
            {errors.precioUnitario && (
              <Typography color="error" variant="body2">
                {errors.precioUnitario}
              </Typography>
            )}
          </div>
          {/* Importe */}
          <div style={{ width: "33%" }}>
            <Typography variant="subtitle1">Precio total ($)</Typography>
            <TextField
              variant="outlined"
              fullWidth
              type="number"
              inputProps={{ min: 0 }}
              value={formData.precioTotal}
              error={!!errors.precioTotal || undefined}
              disabled
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || Number(value) >= 0) {
                  setFormData({ ...formData, precioTotal: value });
                }
              }}
              onKeyDown={(e) => {
                if (["e", "E", "+", "-", "."].includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />
          </div>
        </div>
        {/* Fila 2: Descripción */}
        <div className={classes.formRow}>
          <div className={classes.descriptionField}>
            <Typography variant="subtitle1">Descripción del Item</Typography>
            <TextField
              variant="outlined"
              fullWidth
              multiline
              rows={3}
              value={formData.descripcion}
              // onChange={(e) => setDescripcion(e.target.value)}
              onChange={(e) =>
                setFormData({ ...formData, descripcion: e.target.value })
              }
            />
          </div>
        </div>
      </DialogContent>
      <DialogFooter>
        <BotonGenerico
          tipo={"guardar"}
          color="primary"
          onClick={handleSave}
          text="Guardar"
        />
        <BotonGenerico color="secondary" onClick={onClose} text="Cancelar" />
      </DialogFooter>
    </Dialog>
  );
};

export default AgregarItemsModal;
